import { FC, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useMediaQuery } from "react-responsive";
import { useLocation } from "react-router";

import { maxMobileMediaWidth } from "config/constants";
import { paths } from "config/paths";

import PlusIcon from "components/Icons/PlusIcon";
import Button from "components/Buttons/Button";

import { openModal } from "store/modals/actions";
import { EModals } from "store/modals/types";
import { priorityStateSelector } from "store/priority/selector";
import { getUserInfoDataSelector } from "store/user/selectors";

import { hasRiskPermission } from "utils/hasRiskPermission";

const AMLRiskSettingsCustomButton: FC = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const isMaxMobile = useMediaQuery({ query: `(max-width: ${maxMobileMediaWidth}px)`, });
  const { pathname } = useLocation();
  const priority = useSelector(priorityStateSelector());
  const userInfo = useSelector(getUserInfoDataSelector);

  const handleClick = () => {
    if(!hasRiskPermission(userInfo)) return;
    if(pathname === paths.CUSTOM_LABELS) {
      dispatch(openModal({ modal:EModals.customLabelsGroupAddGroup }));
      return;
    }
    if(pathname === paths.CUSTOM_LABELS_CUSTOM_CATEGORIES) {
      dispatch(openModal({ modal:EModals.customLabelsAddCustomCategory }));
      return;
    }
    if (isMaxMobile) {
      dispatch(openModal({ modal:EModals.riskModelUnavailableAdd }));
      return;
    }
    dispatch(openModal({ modal:EModals.riskModelCreate }));
  };
  const title = useMemo(() => {
    switch (pathname) {
    case paths.CUSTOM_LABELS:
      return t("amlRiskCustomLabels.createLabelGroup");
    case paths.CUSTOM_LABELS_CUSTOM_CATEGORIES:
      return t("amlRiskCustomLabels.addCategory");
    default:
      return t("amlRiskSettings.addCustomModel");
    }
  },[pathname,t]);

  if(pathname === paths.CUSTOM_LABELS_CUSTOM_CATEGORIES && isMaxMobile) {
    return <PlusIcon className="custom-categories-header-right" onClick={(handleClick)}/>;
  }

  return <Button
    disabled={priority}
    title={title}
    onClick={handleClick}
    lettuce={true}
    icon={<PlusIcon />}
    className="aml-risk-settings__models__custom__add-btn"
  />;
};

export default AMLRiskSettingsCustomButton;